import { TICK_MS } from './constants';
/** Канонічний fixed-timestep + variable render loop. */
export function startLoop({ tick, render, onFps }) {
    let last = performance.now();
    let acc = 0;
    let fpsAccum = 0;
    let fpsFrames = 0;
    function frame(now) {
        let dt = now - last;
        last = now;
        if (dt > 250)
            dt = 250; // антидрейф у фоновій вкладці
        acc += dt;
        while (acc >= TICK_MS) {
            tick();
            acc -= TICK_MS;
        }
        render(acc / TICK_MS);
        fpsAccum += dt;
        fpsFrames += 1;
        if (onFps && fpsAccum >= 500) {
            onFps(Math.round((1000 * fpsFrames) / fpsAccum));
            fpsAccum = 0;
            fpsFrames = 0;
        }
        requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
}
